export function layoutsProvider() {
  const layouts = {};

  this.register = (name, fn) => {
    layouts[name] = fn;
  };

  this.$get = () => {
    return {
      get: name => layouts[name],
    };
  };
}
